import React from 'react'
import injectStyles from 'react-jss'

import { Col, Grid, Row } from 'react-bootstrap'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { useHistory } from 'react-router-dom'
import UserDocumentsTable from '../../../../../../Components/UserDocumentsTable'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../Components/GenericFlatButton'

const IdentificationFilesSection = ({
  ambassador,
  documents,
  updateUserDocument,
  documentTypesList,
  setDocuments,
  nmbrsDocument,
  setNmbrsDocument,
  classes,
  user,
}) => {
  const history = useHistory()

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <div className={classes.headerContainer}>
              <div
                className={classes.title}
                cypress_id={'identificationFilesTitle'}
              >
                Identification Files
              </div>
              <GenericFlatButton
                type={'outline'}
                title={'Detailed view'}
                onClick={() =>
                  history.push(history.location.pathname + '/upload-documents')
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <UserDocumentsTable
            setDocuments={setDocuments}
            nmbrsDocument={nmbrsDocument}
            setNmbrsDocument={setNmbrsDocument}
            documents={documents}
            updateUserDocument={updateUserDocument}
            ambassador={ambassador}
            user={user}
          />
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(IdentificationFilesSection)
